import userManager from "./UserManager";
export default {
  userManager: userManager,
  getUser(redirectToLogin = true) {
    return userManager.getUser().then(user => {
      if (user == null || user.expired) {
        if (redirectToLogin) this.login();

        return null;
      } else {
        return user;
      }
    });
  },
  login() {
    return userManager.signinRedirect();
  },
  logout() {
    return userManager.signoutRedirect();
  },
  getToken() {
    return this.getUser().then(user => {
      return user? user.access_token : null;
    });
  },
  isAuthenticated(redirect = false) {
    return this.getUser(redirect).then(user => {
      return user !== null && !user.expired;
    });
  }
};
